import React, { useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import ActionTable from "../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import { mergeParams } from "../../helpers/helpers";

export default function Lista({ history, location }) {
  const [filtros, setFiltros] = useState(
    mergeParams({ nome: "", ativas: false }, location)
  );
  const [escolas, setEscolas] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    carregarEscolas();
  }, []);

  const carregarEscolas = (filtrosEnviar = filtros) => {
    setFiltros(filtrosEnviar);
    setCarregando(true);
    console.log("filtrosEnviar", filtrosEnviar);
    api.get("escolas/listar", filtrosEnviar).then((res) => {
      setEscolas(res);
      setCarregando(false);
    });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 10,
        value: filtros.nome,
      },
      ativas: {
        type: "check",
        label: "Ativas",
        space: 2,
        value: filtros.ativas,
      },
    },

    submit: {
      label: "Buscar",
      action: carregarEscolas,
    },

    urlParams: true,
    history,
    location,
  };

  const abrirDados = (registro) => {
    history.push(`/app/escola/${registro.id}`);
  };

  const tRegistros = {
    title: "Escolas",
    onLineClick: abrirDados,
    newItemAction: () => history.push("/app/escola/0"),

    columns: [
      {
        label: "Nome",
        name: "nomeFantasia",
      },
      {
        label: "Múnicipio",
        name: "municipio",
      },
      {
        label: "Estado",
        name: "UF",
      },
      {
        label: "Ativa",
        name: "ativa",
        checkbox: true,
      },
    ],
    array: escolas,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
